import {
  type DisplayMessage,
  MessageStatus,
  MessageType,
} from "@/api/ai/types";

// The chat window's list model (ChatWindow renders it virtualized): the
// greeting on an empty conversation, one row per message, the generating
// indicator while an answer is on its way — or, while a chat's history
// is still being fetched, a skeleton alone (an unloaded chat is not an
// empty one). Pure, so the rules have tests.

export type ChatRow =
  | { kind: "skeleton"; key: string }
  | { kind: "greeting"; key: string }
  | { kind: "message"; key: string; message: DisplayMessage }
  | { kind: "generating"; key: string };

export function chatRows(
  messages: DisplayMessage[],
  generating: boolean,
  loading = false,
): ChatRow[] {
  if (loading) return [{ kind: "skeleton", key: "skeleton" }];
  const rows: ChatRow[] = [];
  if (messages.length === 0) rows.push({ kind: "greeting", key: "greeting" });
  for (const message of messages) {
    if (
      message.type === MessageType.User ||
      message.type === MessageType.Assistant
    ) {
      rows.push({ kind: "message", key: message.messageId, message });
    }
  }
  if (generating) rows.push({ kind: "generating", key: "generating" });
  return rows;
}

/** What the last message says about the generating indicator: it shows
 *  from a pending prompt, hides as soon as the answer streams, and
 *  otherwise hides a beat later (a settled conversation). */
export function loadingIndicatorFor(
  last: DisplayMessage | undefined,
): "show" | "hide" | "hide-later" {
  if (last?.type === MessageType.User && last.status === MessageStatus.Pending)
    return "show";
  if (
    last?.type === MessageType.Assistant &&
    last.status === MessageStatus.Streaming
  )
    return "hide";
  return "hide-later";
}
